'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var handleToggle = function handleToggle(props) {
	return function () {
		return props.toggle({
			categoryId: props.data.categoryId
		});
	};
};

var getLinkTitle = function getLinkTitle(linkTitle, children) {
	if (linkTitle && children.length !== 0) {
		return false;
	}

	if (linkTitle && children.length === 0) {
		return true;
	}

	return true;
};

var getIcon = function getIcon(props) {
	var children = props.children,
	    iconClosed = props.iconClosed,
	    iconOpen = props.iconOpen,
	    isOpen = props.isOpen,
	    linkTitle = props.linkTitle;

	var icon = isOpen ? iconOpen : iconClosed;
	var linkInTitle = getLinkTitle(linkTitle, children);

	if (!icon) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}

	try {
		var parsedIcon = JSON.parse(icon);

		return (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': 'CMS-SubMenuNode-toggler', onClick: linkInTitle && handleToggle(props) },
			(0, _magicVirtualElement2.default)('i', { 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name })
		);
	} catch (err) {
		return (0, _magicVirtualElement2.default)('noscript', null);
	}
};

var renderTitle = function renderTitle(_ref) {
	var children = _ref.children,
	    data = _ref.data,
	    linkTitle = _ref.linkTitle,
	    styleClasses = _ref.styleClasses;

	var linkInTitle = getLinkTitle(linkTitle, children);

	if (linkInTitle && data.linkFriendlyName) {
		return (0, _magicVirtualElement2.default)(
			_linkWrapper2.default,
			{ href: '' + (data.linkFriendlyName.startsWith('/') ? '' : '/') + data.linkFriendlyName, 'class': styleClasses.Node_Link, 'data-style-attr': 'Node_Link' },
			data.categoryName
		);
	}

	if (linkTitle && !data.linkFriendlyName) {
		return (0, _magicVirtualElement2.default)(
			'span',
			{ 'class': styleClasses.Node_Link, 'data-style-attr': 'Node_Link' },
			data.categoryName
		);
	}

	return (0, _magicVirtualElement2.default)(
		'span',
		null,
		data.categoryName
	);
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var children = props.children,
	    data = props.data,
	    isOpen = props.isOpen,
	    parentChildren = props.parentChildren,
	    parentLinkPrefix = props.parentLinkPrefix,
	    renderParentLink = props.renderParentLink,
	    styleClasses = props.styleClasses,
	    level = props.level,
	    linkTitle = props.linkTitle,
	    cmsNode = props.cmsNode;

	var hasParentChildren = parentChildren && parentChildren.length !== 0;
	var linkInTitle = getLinkTitle(linkTitle, children);
	var path = props.path && props.path.startsWith('/') ? props.path.substring(1) : props.path;
	var classes = _defineProperty({
		'CMS-SubMenuNode--open': isOpen,
		'CMS-SubMenuNode--active': path === data.linkFriendlyName
	}, 'CMS-SubMenuNode-level--' + level, true);

	var parentItemClasses = _defineProperty({
		'CMS-SubMenuNode--active': path === data.linkFriendlyName
	}, 'CMS-SubMenuNode-level--' + (level + 1), true);

	var content = (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-SubMenuNode', classes, props.class, styleClasses.Node], 'data-style-attr': 'Node' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-SubMenuNode-content', styleClasses.Node_Content], 'data-style-attr': 'Node_Content', onClick: !linkInTitle && handleToggle(props) },
			hasParentChildren && (0, _magicVirtualElement2.default)(
				'div',
				{ 'class': ['CMS-SubMenuNode-customContent', styleClasses.Node_Custom_Content], 'data-style-attr': 'Node_Custom_Content' },
				parentChildren
			),
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': ['CMS-SubMenuNode-title', styleClasses.Node_Title], 'data-style-attr': 'Node_Title' },
				renderTitle(props)
			),
			children.length !== 0 && getIcon(props)
		),
		children.length !== 0 && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-SubMenuNode-children', styleClasses.Node_Children, isOpen && 'CMS-SubMenuNode-children--open'], 'data-style-attr': 'Node_Children' },
			renderParentLink && (0, _magicVirtualElement2.default)(
				'div',
				{ 'class': ['CMS-SubMenuNode', parentItemClasses, props.class, styleClasses.Node], 'data-style-attr': 'Node' },
				(0, _magicVirtualElement2.default)(
					'div',
					{ 'class': ['CMS-SubMenuNode-content', styleClasses.Node_Content], 'data-style-attr': 'Node_Content' },
					(0, _magicVirtualElement2.default)(
						'div',
						{ 'class': ['CMS-SubMenuNode-title', styleClasses.Node_Title], 'data-style-attr': 'Node_Title' },
						(0, _magicVirtualElement2.default)(
							_linkWrapper2.default,
							{ href: '' + (data.linkFriendlyName.startsWith('/') ? '' : '/') + data.linkFriendlyName, 'class': styleClasses.Node_Link, 'data-style-attr': 'Node_Link' },
							parentLinkPrefix,
							data.categoryName
						)
					)
				)
			),
			children
		)
	);

	if (cmsNode) {
		return (0, _createCmsComponent2.default)(content, props);
	}

	return content;
};

exports.default = { render: render };